import { BadgeDollarSign, BadgePercent, Gift } from 'lucide-react'
import { formatPrice } from '@/utils/util'

export type CampaignDiscountInfo = {
  icon: any
  label: string
  suffix: string
  color: string
}

export function getCampaignDiscountInfo(targets: any[]): CampaignDiscountInfo | null {
  if (!targets || targets.length === 0) return null
  const target = targets[0]
  if (target.valueType === 'percent' && target.valuePercent) {
    if (target.valuePercent >= 100) {
      return { icon: Gift, label: 'Үнэгүй', suffix: '', color: 'bg-green-100 text-green-600' }
    }
    return { icon: BadgePercent, label: `-${target.valuePercent}%`, suffix: 'хувиар хямдарна', color: 'bg-red-100 text-red-600' }
  }
  if (target.valueType === 'amount' && target.valueAmount) {
    return { icon: BadgeDollarSign, label: String(formatPrice(`-${target.valueAmount}`) || ''), suffix: 'төгрөгөөр хямдарна', color: 'bg-blue-100 text-blue-600' }
  }
  if (target.valueType === 'free') {
    return { icon: Gift, label: 'Үнэгүй', suffix: '', color: 'bg-green-100 text-green-600' }
  }
  return null
}

export type CampaignTargetInfo =
  | { type: 'all' }
  | { type: 'category', categoryIds: string[] }
  | { type: 'product', productIds: string[] }
  | { type: 'none' }

export function getCampaignTargetInfo(targets: any[]): CampaignTargetInfo {
  if (!targets || targets.length === 0) return { type: 'none' }
  const allProductsTarget = targets.find((t: any) => (t.role === 'target' || t.role === 'trigger') && t.targetId === null)
  if (allProductsTarget) return { type: 'all' }
  const categoryTargets = targets.filter((t: any) => t.targetType === 'category' && (t.role === 'target' || t.role === 'trigger') && t.targetId)
  if (categoryTargets.length > 0) return { type: 'category', categoryIds: categoryTargets.map((t: any) => t.targetId) }
  const productTargets = targets.filter((t: any) => t.targetType === 'product' && t.targetId)
  if (productTargets.length > 0) return { type: 'product', productIds: productTargets.map((t: any) => t.targetId) }
  return { type: 'none' }
}

export type CampaignStatus = 'upcoming' | 'active' | 'expired'

export function getCampaignStatus(startDate: string | null | undefined, endDate: string | null | undefined, now: Date = new Date()): CampaignStatus {
  const active = startDate ? new Date(startDate) <= now : true
  const expired = endDate ? new Date(endDate) < now : false
  if (expired) return 'expired'
  if (!active) return 'upcoming'
  return 'active'
}

export type CountdownParts = { d: number, h: number, m: number, s: number }

export function getCountdownParts(endDate: string, now: Date = new Date()): CountdownParts | null {
  const diff = new Date(endDate).getTime() - now.getTime()
  if (diff <= 0) return null
  return {
    d: Math.floor(diff / (1000 * 60 * 60 * 24)),
    h: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    m: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    s: Math.floor((diff % (1000 * 60)) / 1000),
  }
}
